export default {
  row1: [
    {
      column: "column1",

      rows: {
        row1: [
          {
            name: "importProductReImportSBNO",
            label: "S/B Number",
            component: "text-field",
            width: "50%",
            required: true,
          },
          {
            name: "exportProductReExportBENumber",
            label: "init",
            component: "outlinebutton",
            width: "10%",
            sx: {
              mt: "4.5%",
            },
            action: "openSubDialog",
            subComponent: "ProductReImportInit",
          },
          {
            name: "importProductReImportSBDate",
            label: "SBDate",
            component: "dateselector",
            width: "50%",
          },
        ],
        row2: [
          {
            name: "importProductReImportPortofexport",
            label: "Port of Export",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getPorts",
            useParams: "general.exportTransportMode",
            endpointWithParams: "portType",
          },
        ],
        row3: [
          {
            name: "importProductReImportSBInvsno",
            label: "SBInvSrNo",
            component: "text-field",
            width: "50%",
            dataType: "int",
            // required: true,
            // regex: "^[0-1]{1}$",
            // regexMessage: "Please enter only one digit number",
            // maxLength: 2,
          },
          {
            name: "importProductReImportSBitemsno",
            label: "SBItemSrNo",
            component: "text-field",
            width: "50%",
            dataType : "int"
          },
        ],
        row4: [
          {
            name: "importProductReImportNotnno",
            label: "Notn No",
            component: "dropdown",
            width: "50%",
            options: [
              { label: "045/2017", value: "045/2017" },
              { label: "046/2017", value: "046/2017" },
              { label: "047/2017", value: "047/2017" },
              { label: "Others", value: "Others" },
            ],
          },
          {
            name: "importProductReImportNotnsno",
            label: "Notn SrNo",
            component: "dropdown",
            width: "50%",
            options: [
              { label: "1A", value: "1A" },
              { label: "1B", value: "1B" },
              { label: "1C", value: "1C" },
              { label: "1D", value: "1D" },
              { label: "1E", value: "1E" },
              { label: "2", value: "2" },
            ],
          },
        ],
        row5: [
          {
            name: "importProductReImportNotnno",

            component: "text-field",
            width: "50%",
            disabled: true,
          },
          {
            name: "importProductReImportNotnsno",

            component: "text-field",
            width: "50%",
            disabled: true,
          },
        ],
        row6: [
          {
            name: "importProductReImportFreight",
            label: "Freight",
            component: "text-field",
            width: "50%",
            dataType: "float",
          },
          {
            name: "importProductReImportInsurance",
            label: "Insurance",
            component: "text-field",
            width: "50%",
            dataType: "float",
          },
        ],
        row7: [
          {
            name: "importProductReImportCustomDuty",
            label: "Custom Duty",
            component: "text-field",
            width: "50%",
            dataType: "float",
          },
          {
            name: "importProductReImportExciseDuty",
            label: "ExciseDuty",
            component: "text-field",
            width: "50%",
            dataType: "float",
          },
        ],
        row8: [
          {
            name: "importProductReImportIGSTPaid",
            label: "IGST Paid",
            component: "text-field",
            width: "50%",
            dataType: "float",
          },
          {
            name: "importProductReImportFileRefno",
            label: "File No/Ref No",
            component: "text-field",
            width: "50%",
          },
        ],
      },
    },
  ],
};
